import type { Difficulty } from '@beast-keeper/shared';

const BADGES: Record<Difficulty, string> = {
  1: '🌱',
  2: '🍼',
  3: '💪',
};

export default function DifficultyBadge({ difficulty }: { difficulty: Difficulty }) {
  return <span className="diff-badge">{BADGES[difficulty]}</span>;
}
